import gql from 'graphql-tag';

const RESEND_TEMP_PASSWORD = gql`
  query ResendTempPassword($params: ResendTempPasswordInput!) {
    resendTempPassword(payload: $params) {
      success {
        message
        code
      }
      error {
        message
        code
      }
    }
  }
`;

export default RESEND_TEMP_PASSWORD;
